import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
export var api__getNewArrivals = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(searchParams) {
    var _res$data;
    var search_data, params, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          search_data = {};
          Object.assign(search_data, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, searchParams.filters && {
            filters: searchParams.filters
          }), searchParams.sort && {
            sort: searchParams.sort
          }), searchParams.page && {
            page: searchParams.page
          }), searchParams.size && {
            size: searchParams.size
          }));
          params = new URLSearchParams();
          params.append('search_data', JSON.stringify(search_data));
          _context.n = 1;
          return fetcher().get("/search/index", {
            params: params
          });
        case 1:
          res = _context.v;
          return _context.a(2, (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || null);
      }
    }, _callee);
  }));
  return function api__getNewArrivals(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var api__updateLastSeen = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(notification_id) {
    var _res$data2, data, res, _t;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          data = {
            user_interest_notification_id: notification_id
          };
          _context2.n = 1;
          return fetcher(null, true).post("/user-interest/update-last-seen", data);
        case 1:
          res = _context2.v;
          return _context2.a(2, res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.success);
        case 2:
          _context2.p = 2;
          _t = _context2.v;
          console.error("Error sending notification:", _t);
          return _context2.a(2, false);
      }
    }, _callee2, null, [[0, 2]]);
  }));
  return function api__updateLastSeen(_x2) {
    return _ref2.apply(this, arguments);
  };
}();